import { useQuery } from '@tanstack/react-query';

import type { TokenLeaderboardPayload } from 'lib/saba/tokenLeaderboard';

export default function useTokenLeaderboard() {
  return useQuery<TokenLeaderboardPayload>({
    queryKey: [ 'saba:token-leaderboard' ],
    queryFn: async({ signal }) => {
      const response = await fetch('/node-api/saba-token-leaderboard', { signal });
      if (!response.ok) throw new Error('دریافت رتبه‌بندی توکن‌ها ناموفق بود');
      return response.json() as Promise<TokenLeaderboardPayload>;
    },
    staleTime: 60_000,
    refetchInterval: 60_000,
    retry: 1,
  });
}
